<div class="summary-container">
  <ul class="apps col-12 mb-5">
    @for (app of applications; track app.name; let idx = $index) {
      @if (
        app.name !== 'Actions' &&
        app.name !== 'ClientInfo' &&
        app.name !== 'SummaryPage'
      ) {
        <li
          class="app col-12"
          [ngClass]="{
            expanded: app.expanded,
            positive: app.vars.ModuleStatus?.FlowStatus === 'C',
            neutral:
              app.vars.ModuleStatus?.FlowStatus === 'PPF' ||
              app.vars.ModuleStatus?.FlowStatus === 'OR' ||
              app.vars.ModuleStatus?.FlowStatus === 'O',
            negative: app.vars.ModuleStatus?.FlowStatus === 'R',
          }"
        >
          <div class="col-12 row">
            <div class="col-11 content">
              <h4>
                @switch (app.name.toLowerCase()) {
                  @case ('pp') {
                    <mat-icon class="me-1" svgIcon="pp_icon" />
                  }
                  @case ('aw') {
                    <mat-icon class="me-1" svgIcon="aw_icon" />
                  }
                  @case ('iw') {
                    <mat-icon class="me-1" svgIcon="iw_icon" />
                  }
                  @case ('li') {
                    <mat-icon class="me-1" svgIcon="lw_icon" />
                  }
                }
                {{ app.outline.sections.ShortName }}
              </h4>
              <div class="app-notification-container">
                <div class="app-form-notif">
                  <div
                    class="status"
                    [ngClass]="{
                      positive: app.vars.ModuleStatus?.FlowStatus === 'C',
                      neutral:
                        app.vars.ModuleStatus?.FlowStatus === 'PPF' ||
                        app.vars.ModuleStatus?.FlowStatus === 'OR' ||
                        app.vars.ModuleStatus?.FlowStatus === 'O',
                      negative: app.vars.ModuleStatus?.FlowStatus === 'R',
                    }"
                  >
                    <span class="status-indicator">
                      @switch (app.vars.ModuleStatus?.FlowStatus) {
                        @case ('X') {
                          <!-- Not Opened -->
                          <mat-icon class="me-1">check</mat-icon>Not Required
                        }
                        @case ('R') {
                          <!-- Required Not Opened -->
                          <mat-icon class="me-1">priority_high</mat-icon>
                          Required, Not Opened
                        }
                        @case ('PPF') {
                          <!-- Product Profiler First -->
                          <mat-icon class="me-1" matTooltip="Warning"
                            >close</mat-icon
                          >
                          Run Product Profiler First
                        }
                        @case ('C') {
                          <!-- Completed -->
                          <mat-icon class="me-1" matTooltip="Positive"
                            >check</mat-icon
                          >
                          Complete
                        }
                        @case ('OR') {
                          <!-- Open Required -->
                          <mat-icon class="me-1" matTooltip="Warning"
                            >priority_high</mat-icon
                          >
                          Required, In Progress
                        }
                        @case ('O') {
                          <!-- Opened -->
                          <mat-icon class="me-1" matTooltip="Warning"
                            >priority_high</mat-icon
                          >
                          In Progress
                        }
                      }
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-1 button d-flex justify-content-center align-items-center"
            >
              <button
                type="button"
                mat-icon-button
                class="mb-0"
                (click)="toggleExpand($event, idx)"
              >
                <span
                  class="content-toggle-arrow d-flex justify-content-center align-items-center"
                >
                  <mat-icon>expand_circle_down</mat-icon>
                </span>
              </button>
            </div>
          </div>

          <div class="details w-95 clearfix">
            @if (!app.expanded) {
              @if (
                app.vars.ModuleStatus?.FlowStatus === 'OR' ||
                app.vars.ModuleStatus?.FlowStatus === 'O'
              ) {
                <button
                  type="button"
                  mat-button
                  class="pull-right"
                  color="primary"
                  (click)="completeCase(app.name.toLowerCase())"
                >
                  <mat-icon>arrow_back</mat-icon> Complete Case
                </button>
              }
              @if (
                app.vars.ModuleStatus?.FlowStatus !== 'X' &&
                (app.numPositiveScores > 0 ||
                  app.numNeutralScores > 0 ||
                  app.numNegativeScores > 0)
              ) {
                <div class="app-scores-notif">
                  <span class="notif-title">Results:</span>
                  @if (app.numPositiveScores > 0) {
                    <div class="status positive">
                      <mat-icon matTooltip="Positive">check_circle</mat-icon>
                      <span> {{ app.numPositiveScores }} </span>
                    </div>
                  }
                  @if (app.numNeutralScores > 0) {
                    <div class="status neutral">
                      <mat-icon matTooltip="Warning">error</mat-icon>
                      <span> {{ app.numNeutralScores }} </span>
                    </div>
                  }
                  @if (app.numNegativeScores > 0) {
                    <div class="status negative">
                      <mat-icon matTooltip="Negative">cancel</mat-icon>
                      <span> {{ app.numNegativeScores }} </span>
                    </div>
                  }
                </div>
              }
            }
            @if (app.expanded) {
              <div class="funds-container clearfix">
                @if (app.vars.ProductSelected?.length > 0) {
                  @for (
                    type of app.vars.ProductType;
                    track type.Type;
                    let i = $index
                  ) {
                    @if (
                      (type.Type.toLowerCase() !== 'product' && !stayInPlan) ||
                      (type.Type.toLowerCase() === 'product' &&
                        filterProductSelected(app.vars.ProductSelected)
                          .length &&
                        !stayInPlan)
                    ) {
                      <div
                        class="sub-items"
                        [ngClass]="{
                          'mb-4': i !== app.vars.ProductType.length - 1,
                        }"
                      >
                        <h5 class="mb-1">{{ type.Header }}</h5>
                        <ul class="items-list">
                          @for (
                            item of app.vars[checkProductType(type.Type)];
                            track item.Name
                          ) {
                            @if (
                              (checkProductType(type.Type) ===
                                'ProductSelected' &&
                                item.Type.toLowerCase() ===
                                  type.Type.toLowerCase()) ||
                              checkProductType(type.Type) !== 'ProductSelected'
                            ) {
                              <li class="item-list">
                                @switch (item.ScoreClass) {
                                  @case ('positive') {
                                    <span class="status positive"
                                      ><mat-icon>check_circle</mat-icon></span
                                    >
                                  }
                                  @case ('neutral') {
                                    <span class="status neutral"
                                      ><mat-icon>error</mat-icon></span
                                    >
                                  }
                                  @case ('negative') {
                                    <span class="status negative"
                                      ><mat-icon>cancel</mat-icon></span
                                    >
                                  }
                                }
                                <!-- <span
                                class="score-indicator {{ item.ScoreClass }}"
                              ><mat-icon></mat-icon></span
                              > -->
                                <span>
                                  {{ item.Name }}
                                  @if (item.Amount && item.Amount.length > 0) {
                                    &mdash; {{ item.Amount }}
                                  }
                                </span>
                              </li>
                            }
                          }
                        </ul>
                      </div>
                    }
                  }
                }
              </div>
              <div class="actions-container">
                @if (app.vars.GeneralSettings.EditInfoShow) {
                  <button
                    type="button"
                    mat-button
                    color="primary"
                    (click)="editInfo(app.name.toLowerCase())"
                  >
                    <mat-icon class="me-1">edit</mat-icon>
                    @if (app.vars.GeneralSettings.EditInfoText) {
                      {{ app.vars.GeneralSettings.EditInfoText }}
                    } @else {
                      Edit Information
                    }
                  </button>
                }
                @if (app.vars.GeneralSettings.ViewResultsShow) {
                  <button
                    type="button"
                    mat-button
                    color="primary"
                    (click)="viewResults(app.name.toLowerCase())"
                  >
                    <mat-icon class="me-1">view_list</mat-icon>
                    @if (app.vars.GeneralSettings.ViewResultsText) {
                      {{ app.vars.GeneralSettings.ViewResultsText }}
                    } @else {
                      View Results
                    }
                  </button>
                }
                @if (
                  (app.name.toLowerCase() === 'aw' &&
                    showPrint[app.name.toLowerCase() + '1'].show) ||
                  (app.name.toLowerCase() !== 'aw' &&
                    showPrint[app.name.toLowerCase()].show)
                ) {
                  <button
                    type="button"
                    mat-button
                    color="primary"
                    [disabled]="
                      app.name.toLowerCase() === 'aw'
                        ? showPrint[app.name.toLowerCase() + '1'].disable
                        : showPrint[app.name.toLowerCase()].disable
                    "
                    (click)="getReport($event, app.name.toLowerCase())"
                  >
                    <mat-icon>insert_drive_file</mat-icon>
                    {{
                      app.name.toLowerCase() === 'aw'
                        ? showPrint[app.name.toLowerCase() + '1'].text
                        : showPrint[app.name.toLowerCase()].text
                    }}
                  </button>
                }
                @if (
                  app.name.toLowerCase() === 'aw' &&
                  showPrint[app.name.toLowerCase() + '2'].show
                ) {
                  <button
                    type="button"
                    mat-button
                    color="primary"
                    [disabled]="showPrint[app.name.toLowerCase() + '2'].disable"
                    (click)="
                      getReport($event, app.name.toLowerCase(), 'awClient')
                    "
                  >
                    <mat-icon>insert_drive_file</mat-icon>
                    {{ showPrint[app.name.toLowerCase() + '2'].text }}
                  </button>
                }
                @if (
                  app.name.toLowerCase() === 'aw' &&
                  showPrint[app.name.toLowerCase() + '3'].show
                ) {
                  <button
                    type="button"
                    mat-button
                    color="primary"
                    [disabled]="showPrint[app.name.toLowerCase() + '3'].disable"
                    (click)="
                      getReport($event, app.name.toLowerCase(), 'exchange')
                    "
                  >
                    <mat-icon>insert_drive_file</mat-icon>
                    {{ showPrint[app.name.toLowerCase() + '3'].text }}
                  </button>
                }
                @if (
                  app.vars.ButtonSettings.ButtonShow ||
                  app.vars.ButtonSettings.ButtonShow2 ||
                  app.vars.ButtonSettings.ButtonShow3
                ) {
                  <div class="action-button-container pt-3 ms-3">
                    @if (app.vars.ButtonSettings.ButtonShow) {
                      <button
                        type="button"
                        class="me-2"
                        mat-stroked-button
                        color="primary"
                        [disabled]="!app.vars.ButtonSettings.ButtonActive"
                        (click)="
                          submitCase(
                            $event,
                            app.name.toLowerCase(),
                            app.vars.ButtonSettings
                          )
                        "
                      >
                        {{ app.vars.ButtonSettings.ButtonText
                        }}<mat-icon>navigate_next</mat-icon>
                      </button>
                    }
                    @if (app.vars.ButtonSettings.ButtonShow2) {
                      <button
                        type="button"
                        class="me-2"
                        mat-stroked-button
                        color="primary"
                        [disabled]="!app.vars.ButtonSettings.ButtonActive2"
                        (click)="
                          submitCase(
                            $event,
                            app.name.toLowerCase(),
                            app.vars.ButtonSettings,
                            2
                          )
                        "
                      >
                        {{ app.vars.ButtonSettings.ButtonText2
                        }}<mat-icon>navigate_next</mat-icon>
                      </button>
                    }
                    @if (app.vars.ButtonSettings.ButtonShow3) {
                      <button
                        type="button"
                        class="me-2"
                        mat-stroked-button
                        color="primary"
                        [disabled]="!app.vars.ButtonSettings.ButtonActive3"
                        (click)="
                          submitCase(
                            $event,
                            app.name.toLowerCase(),
                            app.vars.ButtonSettings,
                            3
                          )
                        "
                      >
                        {{ app.vars.ButtonSettings.ButtonText3
                        }}<mat-icon>navigate_next</mat-icon>
                      </button>
                    }
                  </div>
                }
                @if (app.vars.GeneralSettings.ShowInstructionText) {
                  <div class="px-4 instruction-text">
                    {{ app.vars.GeneralSettings.InstructionText }}
                  </div>
                }
              </div>
            }
          </div>
          @if (app.expanded && app.vars.GeneralSettings.ReasonTextShow) {
            <div class="reasons-container px-5 mb-5">
              <ul class="reason-list">
                @for (reason of app.trueRules; track reason) {
                  @if (reason.headline) {
                    <li>
                      {{ reason.headline }}
                    </li>
                  }
                }
              </ul>
            </div>
          }
        </li>
      }
    }
  </ul>
  @if (aiSummaryTool) {
    <div class="mb-2">
      <app-ai-summary
        [title]="true"
        [text]="aiSummaryText"
        [edit]="aiSummaryEdit"
        [aiSummaryData]="aiSummaryData"
        [aiSummaryReadOnly]="aiSummaryReadOnly"
        [summaryLoading]="summaryLoading"
        (summaryCheck)="summaryCheck($event)"
        (summaryTextChange)="summaryTextChange($event)"
        (saveSummary)="saveSummary($event)"
      />
    </div>
  }
  @if (buttonInstructions?.ShowInstructionText) {
    <div class="mb-3 instruction-text">
      {{ instructionText }}
    </div>
  }
  @if (buttons) {
    <div class="buttons">
      @if (buttons.CustomPrintButtonShow) {
        <button
          type="button"
          matButton="elevated"
          class="me-3 mb-2"
          color="primary"
          [disabled]="!buttons.CustomPrintButtonActive"
          (click)="customReport()"
        >
          {{ buttons.CustomPrintButtonText }}
        </button>
      }
      @if (buttons.ConsolidatedPrintButtonShow) {
        <button
          type="button"
          matButton="elevated"
          class="me-3 mb-2"
          color="primary"
          [disabled]="!buttons.ConsolidatedPrintButtonActive"
          (click)="consolidatedReport()"
        >
          {{ buttons.ConsolidatedPrintButtonText }}
        </button>
      }
      @if (buttons.ButtonShow) {
        <button
          type="button"
          matButton="elevated"
          class="me-3 mb-2"
          color="primary"
          [disabled]="
            !buttons.ButtonActive || (aiSummaryTool && !aiSummaryCheckedVar)
          "
          (click)="submitCase($event, 'Actions', buttons)"
        >
          {{ buttons.ButtonText }}
        </button>
      }
      @if (buttons.ButtonShow2) {
        <button
          type="button"
          matButton="elevated"
          class="me-3 mb-2"
          color="primary"
          [disabled]="!buttons.ButtonActive2"
          (click)="submitCase($event, 'Actions', buttons, 2)"
        >
          {{ buttons.ButtonText2 }}
        </button>
      }
      @if (buttons.ButtonShow3) {
        <button
          type="button"
          matButton="elevated"
          class="me-3 mb-2"
          color="primary"
          [disabled]="!buttons.ButtonActive3"
          (click)="submitCase($event, 'Actions', buttons, 3)"
        >
          {{ buttons.ButtonText3 }}
        </button>
      }
      @if (buttons.CMCreateButtonShow) {
        <button
          type="button"
          matButton="elevated"
          class="me-3 mb-2"
          color="primary"
          [disabled]="!buttons.CMCreateButtonActive || disableCreateCm"
          (click)="submitCaseManagement(buttons)"
        >
          {{ buttons.CMCreateButtonText }}
        </button>
      }
      @if (buttons.CMLaunchButtonShow) {
        <button
          type="button"
          matButton="elevated"
          class="me-3 mb-2"
          color="primary"
          [disabled]="!buttons.CMLaunchButtonActive"
          (click)="launchCaseManagement()"
        >
          {{ buttons.CMLaunchButtonText }}
        </button>
      }
      @if (showCopyCase && rights.includes('SelectiveCopyCase')) {
        <button
          type="button"
          matButton="elevated"
          class="me-3 mb-2"
          color="primary"
          (click)="copyCase()"
        >
          <mat-icon>folder_copy</mat-icon> Copy to New Case
        </button>
      }

      @if (buttons.JPMCLearnButtonShow) {
        <button
          type="button"
          matButton="elevated"
          class="me-3 mb-2"
          color="primary"
          [disabled]="!buttons.JPMCLearnButtonActive"
          (click)="jpmcDataCall()"
          >{{ buttons.JPMCLearnButtonText }}</button
        >
      }
    </div>
  }
</div>

<form #samlForm ngNoForm method="POST">
  <input type="hidden" name="SAMLResponse" />
  <input type="hidden" name="Token" />
</form>

<ngx-loading [show]="loading" />
